import { FC } from 'react';
import { Bar } from './Bar';
import { GhostGanttSection } from './GanttTimePicker';
import { TimeSlot, findSlotIndex } from './ganttHelper';

interface Props {
  ghostSection: GhostGanttSection;
  timeSlots: TimeSlot[];
}

export const GanttGhostSection: FC<Props> = ({ timeSlots, ghostSection }) => {
  const sectionStartSlot = findSlotIndex(ghostSection.startTime, timeSlots, true);
  const sectionEndSlot = findSlotIndex(ghostSection.endTime, timeSlots, false);

  return (
    <>
      <Bar
        ghost
        color={ghostSection.color}
        slotCount={timeSlots.length}
        startSlot={sectionStartSlot}
        endSlot={sectionEndSlot}
      />
      {ghostSection.subs?.map((sub, index) => {
        const subSectionStartSlot = findSlotIndex(sub.startTime, timeSlots, true);
        const subSectionEndSlot = findSlotIndex(sub.endTime, timeSlots, false);

        return (
          <Bar
            sub
            key={index}
            ghost
            color={sub.color}
            slotCount={timeSlots.length}
            startSlot={subSectionStartSlot}
            endSlot={subSectionEndSlot}
            tooltip={sub.tooltip}
            icon={sub.Icon}
            iconColor={sub.iconColor}
          />
        );
      })}
    </>
  );
};
